import React from 'react';

const SvgIconCarTest = props => (
  <svg width={276} height={195} viewBox="0 0 597.35 295.82" {...props}>
    <defs>
      <linearGradient id="icon-car-test_svg__a">
        <stop stopColor="#fff" offset={0} />
        <stop stopColor="#fff" stopOpacity={0} offset={1} />
      </linearGradient>
      <linearGradient id="icon-car-test_svg__b">
        <stop stopColor="#d2ffd2" offset={0} />
        <stop stopColor="#09a809" offset={0.865} />
        <stop stopColor="#009600" offset={1} />
      </linearGradient>
      <linearGradient id="icon-car-test_svg__c">
        <stop stopColor="#3fc200" offset={0} />
        <stop stopColor="#2ca900" offset={0.5} />
        <stop stopColor="#0a9600" offset={1} />
      </linearGradient>
      <linearGradient
        id="icon-car-test_svg__r"
        y2={309.86}
        xlinkHref="#icon-car-test_svg__a"
        gradientUnits="userSpaceOnUse"
        x2={-261.16}
        gradientTransform="matrix(.47931 0 0 .4982 627.58 237.96)"
        y1={220.24}
        x1={-298.28}
      />
      <linearGradient
        id="icon-car-test_svg__q"
        y2={309.86}
        xlinkHref="#icon-car-test_svg__a"
        gradientUnits="userSpaceOnUse"
        x2={-261.16}
        gradientTransform="matrix(.47931 0 0 .4982 256.96 240.51)"
        y1={220.24}
        x1={-298.28}
      />
      <linearGradient
        id="icon-car-test_svg__n"
        y2={84.905}
        gradientUnits="userSpaceOnUse"
        x2={153.83}
        gradientTransform="matrix(.47931 0 0 .4982 256.96 240.51)"
        y1={237.28}
        x1={155.67}
      >
        <stop stopColor="#9eecff" offset={0} />
        <stop stopColor="#87efff" offset={1} />
      </linearGradient>
      <radialGradient
        id="icon-car-test_svg__m"
        xlinkHref="#icon-car-test_svg__b"
        gradientUnits="userSpaceOnUse"
        cy={-489.54}
        cx={-425.72}
        gradientTransform="matrix(-.09721 -.36758 .42431 -.12626 692.41 211.62)"
        r={171.96}
      />
      <radialGradient
        id="icon-car-test_svg__l"
        xlinkHref="#icon-car-test_svg__b"
        gradientUnits="userSpaceOnUse"
        cy={227.89}
        cx={-72.264}
        gradientTransform="matrix(-.1029 .36584 -.44055 -.13388 250.7 490.47)"
        r={171.96}
      />
      <linearGradient
        id="icon-car-test_svg__g"
        y2={277.06}
        gradientUnits="userSpaceOnUse"
        x2={159.11}
        gradientTransform="matrix(.47931 0 0 .4982 256.96 240.51)"
        y1={169.74}
        x1={159.11}
      >
        <stop stopColor="#fff" stopOpacity={0} offset={0} />
        <stop stopColor="#fff" stopOpacity={0.637} offset={0.5} />
        <stop stopColor="#fff" stopOpacity={0.505} offset={0.75} />
        <stop stopColor="#fff" stopOpacity={0} offset={1} />
      </linearGradient>
      <linearGradient
        id="icon-car-test_svg__f"
        y2={430.16}
        xlinkHref="#icon-car-test_svg__c"
        gradientUnits="userSpaceOnUse"
        x2={110.21}
        gradientTransform="matrix(.47931 0 0 .4982 256.96 240.51)"
        y1={461.76}
        x1={110.13}
      />
      <linearGradient
        id="icon-car-test_svg__e"
        y2={51.26}
        xlinkHref="#icon-car-test_svg__c"
        gradientUnits="userSpaceOnUse"
        x2={96.014}
        gradientTransform="matrix(.47931 0 0 .4982 256.96 240.51)"
        y1={498.04}
        x1={97.294}
      />
      <radialGradient
        id="icon-car-test_svg__p"
        xlinkHref="#icon-car-test_svg__b"
        gradientUnits="userSpaceOnUse"
        cy={189.36}
        cx={395.06}
        gradientTransform="matrix(-.26385 .83769 -.79004 -.2443 648.89 -93.629)"
        r={27.198}
      />
      <linearGradient
        id="icon-car-test_svg__o"
        y2={255.72}
        gradientUnits="userSpaceOnUse"
        x2={108.63}
        gradientTransform="matrix(.54793 0 0 .58571 276.48 205.31)"
        y1={183.3}
        x1={104.61}
      >
        <stop stopColor="#fff" offset={0} />
        <stop stopColor="#fff" stopOpacity={0} offset={1} />
      </linearGradient>
      <radialGradient
        id="icon-car-test_svg__h"
        gradientUnits="userSpaceOnUse"
        cy={532.03}
        cx={173.11}
        r={61.067}
      >
        <stop offset={0} />
        <stop stopColor="#3c3c3c" offset={0.813} />
        <stop offset={1} />
      </radialGradient>
      <linearGradient
        id="icon-car-test_svg__i"
        y2={534.12}
        xlinkHref="#icon-car-test_svg__a"
        gradientUnits="userSpaceOnUse"
        x2={147.47}
        gradientTransform="translate(56.533 171.34) scale(.67534)"
        y1={430.78}
        x1={137.69}
      />
      <linearGradient
        id="icon-car-test_svg__j"
        y2={549.94}
        gradientUnits="userSpaceOnUse"
        y1={563.98}
        x2={120.11}
        x1={132.7}
      >
        <stop stopColor="#bcbcbc" offset={0} />
        <stop stopColor="#bcbcbc" stopOpacity={0} offset={1} />
      </linearGradient>
      <radialGradient
        id="icon-car-test_svg__k"
        xlinkHref="#icon-car-test_svg__a"
        gradientUnits="userSpaceOnUse"
        cy={532.74}
        cx={177.85}
        r={8.09}
      />
      <filter id="icon-car-test_svg__d" y={-0.487} width={1.036} height={1.975} x={-0.018}>
        <feGaussianBlur stdDeviation={4.544} />
      </filter>
    </defs>
    <g transform="translate(-42.879 -246.44)">
      <rect
        strokeWidth={0.6}
        fillRule="evenodd"
        rx={57.77}
        transform="matrix(.99178 0 0 2.8219 20.732 -862.74)"
        ry={9.143}
        filter="url(#icon-car-test_svg__d)"
        width={509.51}
        stroke="#bcbcbc"
        y={469.7}
        x={81.976}
        height={18.287}
        fill="#666"
        color="#000"
      />
      <path
        d="M478.23 466.07l114.09-7.11 3.56-8.81-13.95-34.55-104.69-5.55c.33 18.67.66-21.85.99 56.02z"
        stroke="#000"
        fillRule="evenodd"
      />
      <path
        d="M311.28 273.97c-87.35.26-141.96 54.18-185.02 88.68 9.41-3.65 19.66-5.65 30.38-5.65 45.85 0 83.07 36.74 83.07 82.01 0 9.9-1.78 19.38-5.03 28.17l215.73-.55c-3.61-9.18-5.59-19.17-5.59-29.61 0-45.28 37.22-82.01 83.07-82.01 16.23 0 31.38 4.61 44.17 12.56-5.07-4.4-9.97-8.17-14.14-10.57-17.25-9.96-54.92-12.09-63.89-13.95-8.88-1.84-11.56-2.3-14.05-4.66-9.26-8.73-80.4-73.32-168.7-64.42z"
        fill="url(#icon-car-test_svg__e)"
        fillRule="evenodd"
      />
      <path
        d="M239.1 451.45l208.92-.57 3.25 16.32H229.36l9.74-15.75z"
        fill="url(#icon-car-test_svg__f)"
        fillRule="evenodd"
        color="#000"
      />
      <path
        opacity={0.992}
        d="M547.35 364.16c20.92 18.66 39.16 38.86 54.26 60.38 6.33-8.03 7.1-24.87 4.58-29.06-10.59-17.6-32.84-28.8-58.84-31.32z"
        fill="#b3b3b3"
        fillRule="evenodd"
      />
      <path
        opacity={0.6}
        d="M248.65 289.63l-1.05.36c-34.77 11.97-65.6 33.53-93.97 57.22-.39.61-3.84 3.42-5.89 5.26-2.33 1.27-5.1 2.95-8.43 5.21 34.04 3.43 73.33 27.02 83.22 53.61 3.72 9.65 5.23 19.85 4.9 30 80.97-.06 161.86-3.79 242.81-4.94 3.29-23.31 19.51-43.67 38.24-60.56 5.87-5.59 12.96-10.4 18.12-16.41 1.22-1.82.18-4.14-.98-5.49.9-.1-.09.26-7.72-1.38-19.59-3.95-41.05-1.4-51.92-19.9-.88-1.49 11.37 18.65 9.68 18.63-65.67-.85-127.61-2.05-184.37-2.49-.29 0-1.18-50.41-1.71-63.07-1.77-.08-11.96 1.52-13.14 1.72-.15 1.19-2.41 60.82-3.26 60.79-33.4-1.42-66.82-.65-103.39-.66 1.34-1.05 2.52-2.33 3.46-3.87 9.65-15.88 46.01-40.63 75.4-54.03z"
        fill="url(#icon-car-test_svg__g)"
        fillRule="evenodd"
      />
      <path
        d="M94.383 451.33l121 14.85 6.28-15.42-14.27-35.97-103.3-5.14-9.707 41.68z"
        stroke="#000"
        fillRule="evenodd"
      />
      <g fillRule="evenodd" color="#000">
        <path
          d="M234.18 532.03a61.067 61.067 0 1 1-122.14 0 61.067 61.067 0 1 1 122.14 0z"
          fill="url(#icon-car-test_svg__h)"
          transform="matrix(.92055 0 0 .92085 -.88 -44.496)"
        />
        <path
          d="M198.274 444.2a39.492 39.505 0 1 1-78.984 0 39.492 39.505 0 1 1 78.984 0z"
          fill="#999"
        />
        <path
          d="M214.68 530.64c-35.79-41.18-46.06 10.36-82.48 0 0-22.77 18.47-41.25 41.24-41.25 22.76 0 41.24 18.48 41.24 41.25z"
          fill="url(#icon-car-test_svg__i)"
          transform="matrix(.92055 0 0 .92085 -.88 -44.496)"
        />
        <path
          d="M136.58 553.79a12.1 9.614 0 1 1-24.2 0 12.1 9.614 0 1 1 24.2 0z"
          transform="matrix(.37268 .47811 -.47852 .37323 355.548 161.084)"
          stroke="url(#icon-car-test_svg__j)"
          strokeWidth={2.321}
          fill="#080808"
        />
        <path
          d="M136.58 553.79a12.1 9.614 0 1 1-24.2 0 12.1 9.614 0 1 1 24.2 0z"
          transform="matrix(-.14574 .58849 -.58899 -.14595 502.588 424.474)"
          stroke="url(#icon-car-test_svg__j)"
          strokeWidth={2.321}
          fill="#080808"
        />
        <path
          d="M136.58 553.79a12.1 9.614 0 1 1-24.2 0 12.1 9.614 0 1 1 24.2 0z"
          transform="matrix(-.55378 .24637 -.24659 -.55461 385.273 703.952)"
          stroke="url(#icon-car-test_svg__j)"
          strokeWidth={2.321}
          fill="#080808"
        />
        <path
          d="M136.58 553.79a12.1 9.614 0 1 1-24.2 0 12.1 9.614 0 1 1 24.2 0z"
          transform="matrix(-.54996 -.25478 .255 -.55079 112.146 786.046)"
          stroke="url(#icon-car-test_svg__j)"
          strokeWidth={2.321}
          fill="#080808"
        />
        <path
          d="M136.58 553.79a12.1 9.614 0 1 1-24.2 0 12.1 9.614 0 1 1 24.2 0z"
          transform="matrix(-.15048 -.5873 .58779 -.1507 -135.749 624.566)"
          stroke="url(#icon-car-test_svg__j)"
          strokeWidth={2.321}
          fill="#080808"
        />
        <path
          d="M136.58 553.79a12.1 9.614 0 1 1-24.2 0 12.1 9.614 0 1 1 24.2 0z"
          transform="matrix(.39123 -.46304 .46343 .39182 -159.057 309.037)"
          stroke="url(#icon-car-test_svg__j)"
          strokeWidth={2.321}
          fill="#080808"
        />
        <path
          d="M136.58 553.79a12.1 9.614 0 1 1-24.2 0 12.1 9.614 0 1 1 24.2 0z"
          transform="matrix(.60563 .0232 -.02321 .60655 69.191 110.787)"
          stroke="url(#icon-car-test_svg__j)"
          strokeWidth={2.321}
          fill="#080808"
        />
        <path
          opacity={0.377}
          d="M183.98 531.08a7.79 7.79 0 1 1-15.58 0 7.79 7.79 0 1 1 15.58 0z"
          transform="matrix(.92055 0 0 .92085 -3.413 -44.841)"
          stroke="#bcbcbc"
          strokeWidth={0.6}
          fill="url(#icon-car-test_svg__k)"
        />
      </g>
      <path
        d="M157.11 356.42c-45.85 0-81.791 36.75-81.791 82.03.487 12.08 12.984 11.71 22.887 15.4 3.864-42.18 27.494-61.19 63.334-60.87 36.7.32 63.47 38.27 53.86 74.22l19.13-.04c3.6-9.17 5.64-18.29 5.64-28.71 0-45.28-37.21-82.03-83.06-82.03z"
        fill="url(#icon-car-test_svg__l)"
        color="#000"
      />
      <g fillRule="evenodd" color="#000">
        <path
          d="M234.18 532.03a61.067 61.067 0 1 1-122.14 0 61.067 61.067 0 1 1 122.14 0z"
          fill="url(#icon-car-test_svg__h)"
          transform="matrix(.92055 0 0 .92085 373.65 -43.689)"
        />
        <path
          d="M572.803 445.006a39.492 39.505 0 1 1-78.984 0 39.492 39.505 0 1 1 78.984 0z"
          fill="#999"
        />
        <path
          d="M214.68 530.64c-35.79-41.18-46.06 10.36-82.48 0 0-22.77 18.47-41.25 41.24-41.25 22.76 0 41.24 18.48 41.24 41.25z"
          fill="url(#icon-car-test_svg__i)"
          transform="matrix(.92055 0 0 .92085 373.65 -43.689)"
        />
        <path
          d="M136.58 553.79a12.1 9.614 0 1 1-24.2 0 12.1 9.614 0 1 1 24.2 0z"
          transform="matrix(.37268 .47811 -.47852 .37323 730.078 161.89)"
          stroke="url(#icon-car-test_svg__j)"
          strokeWidth={2.321}
          fill="#080808"
        />
        <path
          d="M136.58 553.79a12.1 9.614 0 1 1-24.2 0 12.1 9.614 0 1 1 24.2 0z"
          transform="matrix(-.14574 .58849 -.58899 -.14595 877.117 425.281)"
          stroke="url(#icon-car-test_svg__j)"
          strokeWidth={2.321}
          fill="#080808"
        />
        <path
          d="M136.58 553.79a12.1 9.614 0 1 1-24.2 0 12.1 9.614 0 1 1 24.2 0z"
          transform="matrix(-.55378 .24637 -.24659 -.55461 759.802 704.76)"
          stroke="url(#icon-car-test_svg__j)"
          strokeWidth={2.321}
          fill="#080808"
        />
        <path
          d="M136.58 553.79a12.1 9.614 0 1 1-24.2 0 12.1 9.614 0 1 1 24.2 0z"
          transform="matrix(-.54996 -.25478 .255 -.55079 486.675 786.853)"
          stroke="url(#icon-car-test_svg__j)"
          strokeWidth={2.321}
          fill="#080808"
        />
        <path
          d="M136.58 553.79a12.1 9.614 0 1 1-24.2 0 12.1 9.614 0 1 1 24.2 0z"
          transform="matrix(-.15048 -.5873 .58779 -.1507 238.78 625.373)"
          stroke="url(#icon-car-test_svg__j)"
          strokeWidth={2.321}
          fill="#080808"
        />
        <path
          d="M136.58 553.79a12.1 9.614 0 1 1-24.2 0 12.1 9.614 0 1 1 24.2 0z"
          transform="matrix(.39123 -.46304 .46343 .39182 215.472 309.844)"
          stroke="url(#icon-car-test_svg__j)"
          strokeWidth={2.321}
          fill="#080808"
        />
        <path
          d="M136.58 553.79a12.1 9.614 0 1 1-24.2 0 12.1 9.614 0 1 1 24.2 0z"
          transform="matrix(.60563 .0232 -.02321 .60655 443.72 111.594)"
          stroke="url(#icon-car-test_svg__j)"
          strokeWidth={2.321}
          fill="#080808"
        />
        <path
          opacity={0.377}
          d="M183.98 531.08a7.79 7.79 0 1 1-15.58 0 7.79 7.79 0 1 1 15.58 0z"
          transform="matrix(.92055 0 0 .92085 371.116 -44.034)"
          stroke="#bcbcbc"
          strokeWidth={0.6}
          fill="url(#icon-car-test_svg__k)"
        />
      </g>
      <path
        d="M526.79 353.38c45.85 0 55.59 23.27 79.87 54.57 6.37 8.2-10.08 41.45-13.67 50.81l-3.96-.7c2.17-41.41-19.43-65.13-56.28-66.53-27.54.1-61.49 20.96-54.08 75.21l-29.38.51c-3.59-9.36-5.56-19.53-5.56-30.16 0-46.21 37.2-83.71 83.06-83.71z"
        fill="url(#icon-car-test_svg__m)"
        color="#000"
      />
      <path
        d="M291.11 284.96l2.64 62.48 176.89 2.06c-48.14-50.35-111.83-74.32-179.53-64.54zm-16.46 3.32c-64.87 15.91-96.67 57.82-96.67 57.82l94.14 1.09 2.53-58.91z"
        fillRule="evenodd"
        stroke="#087900"
        strokeWidth={1.026}
        fill="url(#icon-car-test_svg__n)"
      />
      <path
        opacity={0.958}
        d="M320.99 288.51c-7.95.04-15.88.54-23.77 1.5.65 17.15 1.35 34.3 2.11 51.45 53.15.61 106.29 1.18 159.44 1.76-37.38-34.15-86.97-55.42-137.78-54.71zm-51.53 7.12c-29.28 8.2-56.8 23.33-78.74 44.62 26.14.14 52.29.67 78.44.76.49-15.26 1.54-30.5 1.73-45.77l-1.43.39z"
        fill="url(#icon-car-test_svg__o)"
        fillRule="evenodd"
      />
      <path
        d="M433.81 199.02a27.198 22.439 0 1 1-54.39 0 27.198 22.439 0 1 1 54.39 0z"
        fill="url(#icon-car-test_svg__p)"
        transform="matrix(.47931 0 0 .4982 267.11 242.52)"
        color="#000"
      />
      <path
        d="M283.38 284.45c-1.08 0-2.74 103.66 0 167.34"
        stroke="#076c00"
        strokeWidth={1.368}
        fill="none"
      />
      <path
        opacity={0.969}
        d="M156.36 360.79c-24.94-2.74-64.165 15.24-72.429 55.45 39.709-71.29 101.35-40.66 103.17-43.96-9.15-6.44-19.79-10.35-30.74-11.49z"
        fill="url(#icon-car-test_svg__q)"
        color="#000"
      />
      <path
        opacity={0.969}
        d="M526.98 358.24c-24.95-2.74-64.17 15.24-72.43 55.44 39.7-71.28 101.34-40.65 103.16-43.95-9.15-6.44-19.78-10.35-30.73-11.49z"
        fill="url(#icon-car-test_svg__r)"
        color="#000"
      />
      <path
        opacity={0.155}
        d="M444.77 451.66c-38.05 1.19-76.15.34-114.22.76-30.11.12-60.52-.19-90.45.64-4.77 4.32-.09 3.8 4.48 3.49 67.24-.36 134.48-.02 201.72-.14-.57-1.13.35-4.79-1.53-4.75z"
        fillRule="evenodd"
        fill="#fff"
        color="#000"
      />
    </g>
  </svg>
);

export default SvgIconCarTest;
